export const TruPakRelativeColumnWidths = [
  // numbers must sum to 100
  7.38, 7.38, 7.18, 9.68, 5, 5, 4.78, 3.5, 7.48, 7.48, 6.25, 6.25, 7.48, 7.48,
  7.48,
];
